<template>
  <div>
    <div
      v-if="actions.length > 0"
      class="tw-mx-2 tw-flex tw-items-center tw-justify-between tw-gap-3 tw-py-4 tw-font-outfit tw-text-xs tw-font-bold tw-text-gray-700"
    >
      <h3 class="tw-w-1/2">FILE NAME</h3>
      <h3 class="tw-flex-1">ACTION</h3>
      <EllipsisIcon class="tw-mr-3" />
    </div>

    <div
      v-for="action in actions"
      :key="action?.id"
      class="tw-flex tw-items-center tw-justify-center"
    >
      <div class="tw-w-full">
        <FilesFileListItem
          v-for="document in action?.documents"
          :key="document?.id"
          :document="document"
          :action="action"
          :chip-labels="chipLabels"
          :screening-status="getDocumentScreeningStatus(action)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ActionRequestStatus,
  ActionRequestType,
  ActionRequestScreening,
  ActionRequestScreeningStatus,
} from '@torticity/types'

import EllipsisIcon from '~icons/heroicons-solid/dots-horizontal'

const props = defineProps<{
  actions: Array<{
    id: string
    type: ActionRequestType
    subType: string
    status: ActionRequestStatus
    screening: ActionRequestScreening[]
    documents: Array<{
      id: string
      fileName: string
      fileType: string
      createdAt: string
      signedUrl: string
    }>
  }>
  chipLabels: Record<ActionRequestStatus, string>
}>()

function getDocumentScreeningStatus(
  action: typeof props.actions[0],
): ActionRequestScreeningStatus | undefined {
  if (action.status !== ActionRequestStatus.SCREENED || !action.screening) {
    return undefined
  }

  try {
    const screeningArray = action.screening as any[]

    if (Array.isArray(screeningArray) && screeningArray.length > 0) {
      for (const entry of screeningArray) {
        if (entry.screeningStatus === 'Rejected') {
          return ActionRequestScreeningStatus.REJECTED
        }
        if (entry.screeningStatus === 'Approved') {
          return ActionRequestScreeningStatus.APPROVED
        }
      }
    }

    return ActionRequestScreeningStatus.APPROVED
  } catch (error) {
    console.error('Error determining screening status:', error)
    return ActionRequestScreeningStatus.APPROVED
  }
}
</script>
